import React from 'react';
import HomeScreen from "../../Screens/Home/Home.screen";
import Login from "../../Screens/Login/Login.screen";

const AntiAuthGuard = ({children, isAuthenticated}) => {
    return isAuthenticated ? <HomeScreen /> : <Login />
};

export default AntiAuthGuard;